<svg #svg [attr.width]="_options.width" [attr.height]="_options.height">
  <g [zoomableOf]="svg">
    <g [linkVisual]="link" *ngFor="let link of links"></g>
    <g [nodeVisual]="node" *ngFor="let node of nodes"
        [draggableNode]="node" [draggableInGraph]="graph"></g>
  </g>
</svg>